import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { ReactElement } from 'react'
import styled from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import Grid from 'components/Grid'
import Header from 'components/Header'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const modules: { [key: string]: ReactElement } = {
    grid: <Grid selectedCategory={properties?.category} colorMode={colorMode}/>,
    header: (
      <Header
        title='Die grosse Zürcher Bilanz'
        lead='Kein anderer Kanton schickt so viele Leute ins Bundeshaus: Welche Zürcher Nationalrätinnen und Nationalräte in den letzten vier Jahren besonders aufgefallen sind – und welche weniger.'
        tenant={tenant}
      />
    ),
  }

  return (
    <AppContainer
      isHeader={properties.module === 'header'}
      $colorMode={colorMode}
    >
      {modules[properties.module]}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)<{ isHeader: boolean }>`${GlobalVariables}
  //hacky stuff
  z-index: ${(prop) => (prop.isHeader ? 99999 : 1)};
  position: relative;
  top: ${(prop) => (prop.isHeader ? '-16px' : 0)};
  @media (min-width: 1931px) {
    margin: ${(prop) => (prop.isHeader ? '0 -25%' : 'unset')};
  }

  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  @media only screen and (max-width: 600px) {
    padding: ${(prop) => (prop.isHeader ? '0' : '0 2rem')};
  }
`
export default MainComponent
